import './styles.scss'
import React from 'react'
import Radio from '../../Radio'

export const FormRadio = props => {
  return (
    <Radio
      value={props.value}
      name={props.name}
      label={props.label}
      onChange={props.onChange}
      checked={props.checked}
      required={props.required}
      invalid={props.invalid}
    />
  )
}

export default FormRadio